/* Photo Motif — file field label.
   Swaps the capsule's placeholder text for the chosen filename. Vanilla, no
   dependencies. Used by the ask-first form and, in phase 2, by the product
   page upload. */

(function () {
  'use strict';

  function ellipsize(name) {
    if (name.length <= 34) return name;
    return name.slice(0, 20) + '…' + name.slice(-10);
  }

  function bind(input) {
    if (input.dataset.pmFileReady) return;
    input.dataset.pmFileReady = 'true';

    var text = input.closest('label')
      ? input.closest('label').querySelector('[data-pm-file-text]')
      : null;
    if (!text) return;

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      /* dataset.empty, not the text that is there now: the placeholder has to
         survive a file being chosen and then cleared. And it is defaulted,
         because a caller that forgets the attribute would otherwise print the
         word "undefined" inside a form control, which is worse than an empty
         capsule and harder to notice in review. */
      text.textContent = file ? ellipsize(file.name) : text.dataset.empty || '';
      text.classList.toggle('is-filled', Boolean(file));
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pm-file-input]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
